<template>
    <ProgressBar />

    <div class="z-[2] pt-[130px] pb-[50px]">
        <div class="max-w-[958px] mx-auto px-[20px]">
            <label class="text-[20px] text-violet font-bold mb-[20px] block font-title">QUESTION {{ $store.state.progress + 1 }}</label>

            <Question />

        </div>
    </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar.vue';
import Question from '@/components/Question.vue';

    export default {
        name: 'QuizTemplate',
        components: {
            ProgressBar,
            Question
        },
    }
</script>